var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm btn-link mt-3 without-decoration",staticStyle:{"margin":"10px 8px 0px 0px"},on:{"click":function($event){return _vm.ubicateTree(_vm.infoWinContent)}}},[_c('icon-eye'),_vm._v(" Ubicar ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }